import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import store from '../store/configureStore';

import * as HeaderActions from '../actions/Header';
import * as MoffAPIActions from '../actions/MoffAPI';
import * as Header from '../constants/Header';
import UserInterestCheck from '../components/Organisms/UserInterestCheck';

type AllState = ReturnType<typeof store.getState>;

const UserInterestCheckContainer: FC = () => {
  const dispatch = useDispatch();
  const moffAPI = useSelector((state: AllState) => state.moffAPI);
  const appUser = useSelector((state: AllState) => state.appUser);
  const interestCheck = useSelector((state: AllState) => state.interestCheck);

  useEffect(() => {
    (async () => {
      document.title = '興味関心チェック';
      dispatch(HeaderActions.setPage(Header.USER_INTEREST_CHECK));
      await dispatch(MoffAPIActions.getUsers());
      dispatch(MoffAPIActions.duplicateRepeatSort());
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <UserInterestCheck moffAPI={moffAPI} appUser={appUser} interestCheck={interestCheck} />;
};

export default UserInterestCheckContainer;
